<div class="login-container">
  <img
    src="login/corner-logo.png"
    class="logo"
  />
  <div
    class="widget-container"
    [class.app-signup]="useCustomSignup"
  >
    <div id="okta-signin-container"></div>
    <div
      class="signup-link"
      *ngIf="useCustomSignup && !loading"
    >
      Don't have an account?
      <a
        routerLink="/signup"
        queryParamsHandling="preserve"
        >Sign up</a
      >
    </div>
  </div>

  <div
    class="load"
    *ngIf="loading"
  >
    <img
      title="loading"
      class="loading-logo"
      src="/assets/sustainment-icons/sustain-icon-white.png"
    />
  </div>
</div>
